import { DisplayTrixContent } from "@circle-react-uikit/DisplayTrixContent";
import { SeeMoreLess } from "@circle-react-uikit/SeeMoreLess";
import { DisplayTiptapContent } from "@circle-react/components/CommentsV3/Comment/DisplayTiptapContent";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";
import type { Comment } from "@/react/types/Comment";

interface BodyProps {
  comment: Comment;
}

export const Body = ({ comment }: BodyProps) => {
  const { body_trix_content, editor, tiptap_body, updated_at } = comment;
  const isTiptap = editor === "tiptap";

  return (
    <div
      className={classNames(anchorClassNames("post__body"), "text-md")}
      data-testid="comment-body"
    >
      <div
        key={updated_at}
        className={classNames(anchorClassNames("post__inside"), "text-dark")}
        data-testid="comment-body-inside"
      >
        <SeeMoreLess lines={8}>
          {isTiptap ? (
            <DisplayTiptapContent tiptapBody={tiptap_body} />
          ) : (
            <DisplayTrixContent content={body_trix_content} />
          )}
        </SeeMoreLess>
      </div>
    </div>
  );
};
